import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { MobileQuizResultDialogComponent } from '@quiz/components/mobile-quiz-result-dialog/mobile-quiz-result-dialog.component';

@Component({
  selector: 'app-modal-result',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './modal-result.component.html',
  styleUrls: ['./modal-result.component.scss'],
})
export class ModalResultComponent extends MobileQuizResultDialogComponent {
  protected override dialogRef = inject(MatDialogRef<ModalResultComponent>);
}
